import createFetchClient from "openapi-fetch";
import createClient from "openapi-react-query";

import config from "@/config.ts";

import type { paths } from "./generated/ops-api-schema.ts";

const fetchClient = createFetchClient<paths>({
  baseUrl: config.apiUrls.opsApi
});

// ops-api logs this as automatClient so its logs can be filtered by client. Accepted values are
// ops-api's AutomatClient enum; anything else is logged as "unrecognized".
const AUTOMAT_CLIENT_HEADER = "Entur-Automat-Client";

let _getToken: () => Promise<string>;

export function initAuth(getToken: () => Promise<string>) {
  _getToken = getToken;
}

fetchClient.use({
  async onRequest({ request }) {
    const token = await _getToken();
    request.headers.set("Authorization", `Bearer ${token}`);
    request.headers.set(AUTOMAT_CLIENT_HEADER, "ops_ui");
    return request;
  }
});

export const $api = createClient(fetchClient);
